import { AppStore, observeStore, store } from '../store';
import { UserState } from '@/types/types';
import { Action, Subject } from '@/types/enums';
import { ability, defineRulesFor } from './defineAbility';

// use example: CAN(Actions.READ, Subjects.page_lotMapEditing)
export default (action: Action, subject: Subject) => {
  return ability.can(action, subject);
};

export const subscribeToUserState = (store: AppStore) => {
  observeStore(
    store,
    (state: any) => state.user,
    (user: UserState) => {
      ability.update(defineRulesFor(user as UserState));
    },
  );
};

// react(subscribe) to changes in the user state and update the ability
subscribeToUserState(store);
